import { ERROR_WORDS } from "@/constants";

export function formatErrorMessage(error){
    let message = error;
    
    // If it's an error object, extract the message first
    if (typeof error === 'object' && error !== null) {
        if (error.response && error.response.data) {
            const errorData = error.response.data;
            
            // Check for specific error message fields
            if (errorData.message) {
                message = errorData.message;
            } else if (errorData.error) {
                message = errorData.error;
            } else if (errorData.detail) {
                message = errorData.detail;
            } else if (errorData.errors) {
                // Handle validation errors
                if (Array.isArray(errorData.errors)) {
                    message = errorData.errors.join(', ');
                } else if (typeof errorData.errors === 'object') {
                    message = Object.values(errorData.errors).flat().join(', ');
                }
            } else if (typeof errorData === 'string') {
                message = errorData;
            } else {
                message = 'An unexpected error occurred. Please try again.';
            }
        } else if (error.message) {
            message = error.message;
        } else {
            message = 'An unexpected error occurred. Please try again.';
        }
    }
    
    // Ensure message is a string before calling toLowerCase
    if (typeof message !== 'string') {
        message = 'An unexpected error occurred. Please try again.';
    }
    
    return ERROR_WORDS.some((i) => message.toLowerCase().includes(i)) ? 'Something went wrong' : message;
}

/**
 * Format error for display - handles both string messages and error objects
 * @param {string|Object} error - Error message string or error object
 * @returns {string} - Formatted error message
 * @deprecated Use formatErrorMessage instead - it now handles both strings and objects
 */
export function formatApiError(error) {
    return formatErrorMessage(error);
}